// extracted by mini-css-extract-plugin
export default {"details_share":"DetailsShare_details_share__x6CV+","shareBTN":"DetailsShare_shareBTN__Eb6j2"};